import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Eyebrow } from './Eyebrow';
function Stars({
  size
}: {
  size: string;
}) {
  return <div className="flex gap-0.5" aria-label="Ocena 5 na 5" data-id="element-339" data-mp="3itvehq2pk1vt">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className={`${size} fill-amber text-amber`} aria-hidden="true" data-id="element-340" data-mp="3mufd6y2xjdk2" data-mpi={index} />)}
    </div>;
}
export function TestimonialWall() {
  const [featured, ...supporting] = testimonials;
  return <section aria-labelledby="reviews-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-341" data-mp="3dvk3hc0oflc0">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-342" data-mp="2zvj7oaz9r43e">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-343" data-mp="2zx41fydrej07">
          <div data-id="element-344" data-mp="33yfkfl24o5zf">
            <Eyebrow data-id="element-345" data-mp="y3efqzhrs6so">Zaufali nam pedagodzy jazzu z całego świata</Eyebrow>
            <h2 id="reviews-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-346" data-mp="y1a4fwhjk5id">
              Co mówią <span className="text-amber" data-id="element-347" data-mp="1wm0etmetp27v">pedagodzy</span>
            </h2>
          </div>
          <p className="flex items-center gap-2 text-sm text-cream-muted" data-id="element-348" data-mp="1roqmnz01ucgc">
            <StarIcon className="h-4 w-4 fill-amber text-amber" aria-hidden="true" data-id="element-349" data-mp="26clivpd9myy6" />
            <span className="font-semibold text-cream" data-id="element-350" data-mp="21ds3tsibyzvw">4,9/5</span> &middot; 2 500+ pedagogów
          </p>
        </div>
        <div className="mt-10 grid gap-5 lg:mt-12 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:gap-6" data-id="element-351" data-mp="1dno0lm92125f">
          <figure className="flex flex-col rounded-2xl border border-amber/40 bg-night-800 p-6 sm:p-10" data-id="element-352" data-mp="18pwa8wo25o3c">
            <Stars size="h-4 w-4" data-id="element-353" data-mp="1nmn9n5xqezsy" />
            <blockquote className="mt-6 font-serif text-2xl italic leading-snug text-cream sm:mt-7 sm:text-3xl" data-id="element-354" data-mp="1nnoqjr1figil">
              &bdquo;{featured.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-4 pt-9" data-id="element-355" data-mp="2z07pl6hsijp9">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber text-xs font-bold tracking-wider text-night" data-id="element-356" data-mp="2u38rkcv09sls">
                {featured.initials}
              </span>
              <span className="text-sm text-cream-muted" data-id="element-357" data-mp="363pbvgqqqcyv">
                <span className="block font-semibold text-cream" data-id="element-358" data-mp="3b3tr73fwx1ni">{featured.name}</span>
                {featured.role} &middot; {featured.location}
              </span>
            </figcaption>
          </figure>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-1" data-id="element-359" data-mp="2ifeguu7q77ii">
            {supporting.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-night-600 bg-night-800 p-6" data-id="element-360" data-mp="2ndpmesqzmvux">
                <Stars size="h-3 w-3" data-id="element-361" data-mp="2scansvhz7lky" />
                <blockquote className="mt-4 text-sm leading-relaxed text-cream-soft" data-id="element-362" data-mp="2sb96486gg0u9">
                  &bdquo;{item.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-5 text-xs text-cream-muted" data-id="element-363" data-mp="1znvdundpbtgh">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-night-600 text-[10px] font-bold text-amber" data-id="element-364" data-mp="24mge2msyed4x">
                    {item.initials}
                  </span>
                  <span data-id="element-365" data-mp="hrjluap8nz51">
                    <span className="font-semibold text-cream" data-id="element-366" data-mp="hp75g1z4pwu3">{item.name}</span> &middot; {item.role}{' '}
                    &middot; {item.location}
                  </span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}